import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Button, Link } from '@gumtree/ui-library';
import {
    removeTrailingZeros,
    setPriceToZeroIfFreebies,
} from '@gumtree/ui-library/src/utils/currency-service';
import { useModal } from '@gumtree/shell/src/use-modal';
import { LoginModalType } from '@gumtree/shell/src/reducers/common/login-modal';
import { TextBtn } from '@gumtree/create-order/src/page/create-order-page.style';
import { VipState } from '../../reducers';
import {
    SellerBuyBlockContainer,
    PriceContainer,
    ItemPrice,
    ExtraPrice,
    PriceDivider,
    BuyButtonContainer,
} from './index.style';

export const renderedDeliveryFromPrice = (deliveryFromPrice) => {
    const priceWidthoutCurrency = deliveryFromPrice?.replace('£', '');
    if (
        priceWidthoutCurrency &&
        priceWidthoutCurrency.trim() !== '' &&
        !isNaN(Number(priceWidthoutCurrency))
    ) {
        return <span>Delivery from {deliveryFromPrice}</span>;
    }
    return (
        <>
            <span>
                <Link href="/manage-postage" text="Add address" /> for delivery
            </span>
        </>
    );
};

export const BuyButton = ({ type }: { type: 'buy' | 'collect' }) => {
    const { id, isCurrentUserSeller, buyerUrl, userData } = useSelector(
        ({
            adDetails: { id, isCurrentUserSeller },
            baseConfig: { buyerUrl },
            userData,
        }: VipState) => ({
            id,
            isCurrentUserSeller,
            buyerUrl,
            userData,
        }),
        shallowEqual
    );
    const { openDialog } = useModal();

    const userLoggedIn = !!userData && userData.userLoggedIn;

    const handleClick = (e) => {
        if (!userLoggedIn) {
            openDialog(e, type === 'buy' ? LoginModalType.DELIVERY : LoginModalType.EMAIL, true);
            return;
        }

        window.location.href =
            type === 'buy'
                ? `/create-order?advertId=${id}`
                : `${buyerUrl}/reply/${id}${isCurrentUserSeller ? `?ius=true` : ``}`;
    };

    return (
        <Button
            display={type === 'buy' ? 'primary' : 'secondary'}
            label={type === 'buy' ? 'I want this item delivered' : 'I want to collect this item'}
            disabled={Boolean(isCurrentUserSeller)}
            onClick={handleClick}
        />
    );
};

const SellerBuyBlock: React.FC<Props> = ({ isMobileCardsLayout, setIsBuyerProtectionOpen }) => {
    const { price, deliveryFromPrice, buyerProtectionPrice, l2CategoryId } = useSelector(
        ({
            adDetails: { price, deliveryFromPrice, buyerProtectionPrice, l2CategoryId },
        }: VipState) => ({
            price,
            deliveryFromPrice,
            buyerProtectionPrice,
            l2CategoryId,
        }),
        shallowEqual
    );

    const renderedPrice = removeTrailingZeros(setPriceToZeroIfFreebies(price, l2CategoryId));

    return (
        <SellerBuyBlockContainer isMobileCardsLayout={isMobileCardsLayout}>
            <PriceContainer>
                <ItemPrice>{renderedPrice}</ItemPrice>
                <ExtraPrice>
                    {deliveryFromPrice}
                    <PriceDivider>|</PriceDivider>
                    <TextBtn type="button" onClick={() => setIsBuyerProtectionOpen?.(true)}>
                        Buyer protection
                    </TextBtn>
                    {buyerProtectionPrice}
                </ExtraPrice>
            </PriceContainer>
            <BuyButtonContainer>
                <BuyButton type="buy" />
                <BuyButton type="collect" />
            </BuyButtonContainer>
        </SellerBuyBlockContainer>
    );
};

interface Props {
    isMobileCardsLayout: boolean;
    setIsBuyerProtectionOpen?: (isOpen: boolean) => void;
}

export default SellerBuyBlock;
